(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .directive("modalCustomerContent", modalCustomerContent);

    /** @ngInject */
    function modalCustomerContent() {
        return {
            restrict: "E",
            scope: {
                customer: '=',
                onClose: "&"
            },
            controller: 'CustomerContentController',
            controllerAs: "vm",
            bindToController: true,
            templateUrl: "app/components/modal/side-modal/body-contents/customer/customer-content.html"
        };


    }
})();
